import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../i18n";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const googleLogin = () => {
  const redirectUrl = window.location.origin + "/account";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const Login = () => {
  const { login } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back");
      nav(user.role === "admin" ? "/admin" : (loc.state?.from || "/account"));
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <h1 className="font-display text-5xl tracking-tighter font-light">{t("sign_in")}</h1>
      <form onSubmit={onSubmit} className="mt-8 space-y-3">
        <input data-testid="login-email" required type="email" placeholder={t("email")} value={email} onChange={(e) => setEmail(e.target.value)} className="border border-black/15 px-4 py-3 text-sm w-full bg-white" />
        <input data-testid="login-password" required type="password" placeholder={t("password")} value={password} onChange={(e) => setPassword(e.target.value)} className="border border-black/15 px-4 py-3 text-sm w-full bg-white" />
        <button data-testid="login-submit" disabled={busy} className="btn-primary w-full text-sm">{t("sign_in")}</button>
      </form>
      <div className="my-5 flex items-center gap-3 text-xs text-ink-muted"><div className="flex-1 border-t border-black/10" />{t("or")}<div className="flex-1 border-t border-black/10" /></div>
      <button data-testid="google-login" onClick={googleLogin} className="btn-secondary w-full text-sm">{t("google_continue")}</button>
      <div className="mt-6 text-sm text-ink-muted">{t("no_account")} <Link to="/register" className="text-ink underline">{t("sign_up")}</Link></div>
    </div>
  );
};

export const Register = () => {
  const { register } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(email, password, name);
      toast.success("Account created");
      nav("/account");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
      <h1 className="font-display text-5xl tracking-tighter font-light">{t("sign_up")}</h1>
      <form onSubmit={onSubmit} className="mt-8 space-y-3">
        <input data-testid="register-name" required placeholder={t("name")} value={name} onChange={(e) => setName(e.target.value)} className="border border-black/15 px-4 py-3 text-sm w-full bg-white" />
        <input data-testid="register-email" required type="email" placeholder={t("email")} value={email} onChange={(e) => setEmail(e.target.value)} className="border border-black/15 px-4 py-3 text-sm w-full bg-white" />
        <input data-testid="register-password" required type="password" minLength={6} placeholder={t("password")} value={password} onChange={(e) => setPassword(e.target.value)} className="border border-black/15 px-4 py-3 text-sm w-full bg-white" />
        <button data-testid="register-submit" disabled={busy} className="btn-primary w-full text-sm">{t("sign_up")}</button>
      </form>
      <div className="my-5 flex items-center gap-3 text-xs text-ink-muted"><div className="flex-1 border-t border-black/10" />{t("or")}<div className="flex-1 border-t border-black/10" /></div>
      <button data-testid="google-register" onClick={googleLogin} className="btn-secondary w-full text-sm">{t("google_continue")}</button>
      <div className="mt-6 text-sm text-ink-muted">{t("have_account")} <Link to="/login" className="text-ink underline">{t("sign_in")}</Link></div>
    </div>
  );
};
